import { render, staticRenderFns } from "./DemoReviewPage.vue?vue&type=template&id=37953d8b"
import script from "./DemoReviewPage.vue?vue&type=script&lang=js"
export * from "./DemoReviewPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports